module.exports = __webpack_public_path__ + "static/media/step-3.a98aa1fa.png";